import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, OnDestroy, Renderer2, NgZone } from '@angular/core';
import { FirebaseTSFirestore, Where, OrderBy } from 'firebasets/firebasetsFirestore/firebaseTSFirestore';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { UserData } from '../../models/user.model';
import { PostData, CommentData } from '../../models/post.model';
import { ChatWindow } from '../../models/chat.model';
import { MatDialog } from '@angular/material/dialog';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ReplyComponent } from '../reply/reply.component';
import { UserService } from 'src/app/services/user.service'; 
import { EditPostDialogComponent } from 'src/app/edit-post-dialog-component/edit-post-dialog-component.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommentDialogComponent } from 'src/app/comment-dialog/comment-dialog.component';
import { ImageModalComponent } from 'src/app/image-modal/image-modal.component';
import { DeletePostDialogComponent } from 'src/app/delete-post-dialog/delete-post-dialog.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ActivatedRoute } from '@angular/router';
import { ChatService } from 'src/app/services/chat.service';
import { Subscription, Observable } from 'rxjs';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { environment } from 'src/environments/environment';
import { initializeApp } from 'firebase/app';
import { 
  Firestore, 
  getFirestore, 
  doc, 
  updateDoc, 
  arrayUnion, 
  arrayRemove, 
  QuerySnapshot, 
  DocumentData,
  Query,
  collection,
  query,
  where,
  orderBy,
  limit,
  getDocs
} from 'firebase/firestore';
import { MediaControlService } from '../../services/media-control.service';

// Initialize Firebase
initializeApp(environment.firebaseConfig);

@Component({
  selector: 'app-post',
  templateUrl: './post.component.html',
  styleUrls: ['./post.component.css']
})
export class PostComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() postData: PostData;
  @Input() userIdToFollow: string;
  @Input() currentUserId: string;
  @Output() messageUser = new EventEmitter<UserData>();
  @Output() videoPlayed = new EventEmitter<HTMLVideoElement>();
  @Output() audioPlayed = new EventEmitter<HTMLAudioElement>();
  @Output() chatSelected = new EventEmitter<any>();
  @ViewChild('videoPlayer') videoPlayer: ElementRef<HTMLVideoElement>;
  @ViewChild('audioPlayer') audioPlayer!: ElementRef<HTMLAudioElement>;
  @ViewChild('postText') postText: ElementRef;

  creatorName: string;
  creatorDescription: string;
  creatorProfilePhotoUrl: string;
  creatorVille: string;
  firestore = new FirebaseTSFirestore();
  auth = new FirebaseTSAuth();
  firestore2 = new FirebaseTSFirestore();
  isOwner: boolean;
  isFollowing: boolean = false;
  formattedDate: string;
  isLiked = false;
  userId: string;
  comments: CommentData[] = [];
  likesCount: number = 0;
  private subscription: Subscription;
  post$: Observable<any>;
  commentCount: number = 0;
  sharesCount: number = 0;
  currentUser: any;
  postId: string;
  showComments: boolean = false;
  commentId: string;
  isExpanded = false;
  isTruncated = false;
  private firestore3: Firestore;
  private observer: IntersectionObserver;
  private mediaSubscription: Subscription;

  isPlaying: boolean = false;
  currentTime: number = 0;
  duration: number = 0;

  volume: number = 1;
  isMuted: boolean = false;
  isFullscreen: boolean = false;
  previousVolume: number = 1;

  youtubePlayerReady: boolean = false;
  isYoutubeVideoPlaying: boolean = false;
  private youtubePlayer: any;
  private pendingPlay: boolean = false;

  // Variables pour le modal d'image
  selectedImage: string | null = null;
  currentImageIndex: number = 0;

  audioLoading: boolean = false;
  isAudioPlaying: boolean = false;
  
  isCreatorCertified: boolean = false;

  constructor(
    private dialog: MatDialog,
    private renderer: Renderer2,
    private bottomSheet: MatBottomSheet,
    private chatService: ChatService,
    private el: ElementRef,
    private route: ActivatedRoute,
    private breakpointObserver: BreakpointObserver,
    private userService: UserService,
    private snackBar: MatSnackBar,
    private zone: NgZone,
    private mediaControlService: MediaControlService
  ) {
    this.firestore3 = getFirestore();
  }

  audioPlayerRef(ref: ElementRef<HTMLAudioElement>) {
    this.audioPlayer = ref;
  }

  ngOnInit(): void {

    this.postId = this.route.snapshot.paramMap.get('postId');
    
    if(this.postId != null) {
      this.loadPost();
    } else {
      this.getCreatorInfo();
      this.checkIfOwner();
      this.checkIfFollowing();
      this.formatTimestamp();
      this.userIdToFollow = this.postData.creatorId;
      this.currentUserId = this.auth.getAuth().currentUser.uid;
      
      // Vérifier et prévisualiser les liens dans le texte du post
      if (this.postData?.comment) {
        this.extractAndPreviewLink(this.postData.comment);
      }
      
      this.listenToPost();
      this.isLiked = (this.postData.likes && this.postData.likes.includes(this.userId)) ? true : false;
      this.commentCount = this.postData.comments ? this.postData.comments.length : 0;
      this.loadComments();
      
      this.listenToPost2();
      this.listenToPost3();
      this.listenToPost4();
      
      this.mediaSubscription = this.mediaControlService.currentMedia$.subscribe(mediaId => {
        if (mediaId && mediaId !== this.postData.postId) {
          if (this.audioPlayer?.nativeElement) {
            this.audioPlayer.nativeElement.pause();
          }
          if (this.videoPlayer?.nativeElement) {
            this.videoPlayer.nativeElement.pause();
          }
        }
      });
    }
    this.audioLoading = false;
  }

  ForAgribox(){
    this.firestore.update({
      path: ['Posts', this.postData.postId],
      data: {
        agribox: true // Ajouter l'UID au champ 'followers'
      },
      onComplete: () => {
        console.log('Agribox avec succès');
       
        
        //this.isFollowing = true;
      },
      onFail: (err) => {
        console.error('Erreur lors du suivi de l\'utilisateur:', err);
      }
    }); 
  }

  ForLenali(){
    this.firestore.update({
      path: ['Posts', this.postData.postId],
      data: {
        lenali: true // Ajouter l'UID au champ 'followers'
      },
      onComplete: () => {
        console.log('Agribox avec succès');
       
        
        //this.isFollowing = true;
      },
      onFail: (err) => {
        console.error('Erreur lors du suivi de l\'utilisateur:', err);
      }
    }); 
  }

  

  async loadUserProfile() {
    const userId = this.auth.getAuth().currentUser.uid; // Assurez-vous de récupérer l'ID utilisateur correctement
    await this.firestore.getDocument({
      path: ["Users", this.auth.getAuth().currentUser.uid],
      onComplete: result => {
        this.currentUser = result.data();
      },
      onFail: err => {
        console.error(err);
      }
    });
  }
  


  onReplyClick() {
    const isMobile = this.breakpointObserver.isMatched('(max-width: 480px)');
    const postId = this.postId ? this.postId : this.postData.postId;
  
    if (isMobile) {
      this.bottomSheet.open(ReplyComponent, {
        data: postId,
        panelClass: 'bottom-sheet-container'
      });
    } else {
      this.dialog.open(ReplyComponent, {
        data: postId,
        width: '500px',
        minWidth: '450px'
      });
    }
  }
  
  

  async loadPost() {
    
    
    await this.firestore.getDocument({
      path: ['Posts', this.postId],
      onComplete: result => {
        
        this.postData = result.data() as PostData; // Charger les données de la publication
       
        
        
        this.checkIfOwner();
        this.checkIfFollowing(); // Vérifie si l'utilisateur suit déjà cet utilisateur
        this.formatTimestamp(); // Formater la date de publication
        this.userIdToFollow = this.postData.creatorId;
        if(this.postData.creatorId){
          this.getCreatorInfo();
          
        }
        
        
        this.currentUserId = this.auth.getAuth().currentUser.uid;
        this.listenToPost();
        this.isLiked = (this.postData.likes && this.postData.likes.includes(this.userId))  ? true : false;
        
        this.loadComments();
        this.listenToPost2();
        
        this.listenToPost3();
       
        this.listenToPost4();
        
        
        
        
      },
      onFail: err => {
        console.error('Erreur de chargement de la publication :', err);
      }
    });
  }

  // Méthode pour envoyer un message à l'utilisateur
  onMessageUser() {
    console.log('onMessageUser appelé');
    if (!this.postData?.creatorId) {
      console.error('ID du créateur non disponible');
      return;
    }

    this.firestore.getDocument({
      path: ["Users", this.postData.creatorId],
      onComplete: (result) => {
        if (result.exists) {
          const userData = result.data() as UserData;
          console.log('Données utilisateur récupérées:', userData);
          this.messageUser.emit(userData);
        } else {
          console.error('Utilisateur non trouvé');
        }
      },
      onFail: (err) => {
        console.error('Erreur lors de la récupération de l\'utilisateur:', err);
      }
    });
  }

  // Méthode pour envoyer un message à l'utilisateur sur mobile
  onMessageUserOnMobile() {
    console.log('onMessageUserOnMobile appelé');
    if (!this.postData?.creatorId) {
      console.error('ID du créateur non disponible');
      return;
    }

    this.firestore.getDocument({
      path: ["Users", this.postData.creatorId],
      onComplete: (result) => {
        if (result.exists) {
          const userData = result.data() as UserData;
          console.log('Données utilisateur récupérées:', userData);
          this.chatSelected.emit(userData);
        } else {
          console.error('Utilisateur non trouvé');
        }
      },
      onFail: (err) => {
        console.error('Erreur lors de la récupération de l\'utilisateur:', err);
      }
    });
  }

  
  

  // Méthode appelée lors de la lecture d'une vidéo
  onPlay(video: HTMLVideoElement) {
    this.videoPlayed.emit(video);  // Émet la vidéo jouée au parent
    this.mediaControlService.playMedia(this.postData.postId);
  }

  // Méthode appelée lors de la lecture d'un fichier audio
  onAudioPlay() {
    this.audioPlayed.emit(this.audioPlayer.nativeElement);  // Émet l'élément audio joué au parent
    this.mediaControlService.playMedia(this.postData.postId);
  }

  ngAfterViewInit(): void {
    this.checkTextOverflow();

    // Créer un observateur pour surveiller la visibilité de la vidéo et de l'audio
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          // Si l'élément n'est plus visible, mettre en pause la vidéo et l'audio
          if (this.videoPlayer?.nativeElement) {
            this.videoPlayer.nativeElement.pause();
          }
          if (this.audioPlayer?.nativeElement) {
            this.audioPlayer.nativeElement.pause();
          }
        } else {
          // Si l'élément devient visible
          if (this.videoPlayer?.nativeElement) {
            this.videoPlayer.nativeElement.play().then(() => {
              this.onPlay(this.videoPlayer.nativeElement);
            }).catch(() => {
              // Gérer l'erreur silencieusement
            });
          }
          if (this.audioPlayer?.nativeElement) {
            this.audioPlayer.nativeElement.play().then(() => {
              this.onAudioPlay();
            }).catch(() => {
              // Gérer l'erreur silencieusement
            });
          }
        }
      });
    });

    // Observer la vidéo et l'audio si présents
    if (this.videoPlayer?.nativeElement) {
      this.observer.observe(this.videoPlayer.nativeElement);
    }
    if (this.audioPlayer?.nativeElement) {
      this.observer.observe(this.audioPlayer.nativeElement);
    }
    
    // Ajouter des écouteurs d'événements pour la vidéo
    if (this.videoPlayer?.nativeElement) {
      const video = this.videoPlayer.nativeElement;
      video.addEventListener('play', () => this.isPlaying = true);
      video.addEventListener('pause', () => this.isPlaying = false);
      video.addEventListener('ended', () => this.isPlaying = false);
    }

    // Écouter les changements d'état plein écran
    document.addEventListener('fullscreenchange', () => {
      this.isFullscreen = !!document.fullscreenElement;
    });
    document.addEventListener('webkitfullscreenchange', () => {
      this.isFullscreen = !!(document as any).webkitFullscreenElement;
    });
    document.addEventListener('mozfullscreenchange', () => {
      this.isFullscreen = !!(document as any).mozFullscreenElement;
    });
    document.addEventListener('MSFullscreenChange', () => {
      this.isFullscreen = !!(document as any).msFullscreenElement;
    });
  }

  ngOnDestroy(): void {
    // Arrêter d'observer lorsque le composant est détruit
    if (this.observer) {
      this.observer.disconnect();
    }

    // Supprimer l'écouteur pour éviter les fuites de mémoire
    if (this.audioPlayer) {
      this.audioPlayer.nativeElement.removeEventListener('play', () => {
        this.onAudioPlay();
      });
    }

    // Supprimer l'observateur et l'écouteur pour éviter les fuites de mémoire
    if (this.audioPlayer) {
      this.audioPlayer.nativeElement.removeEventListener('play', () => {
        this.onAudioPlay();
      });
      if (this.observer) {
        this.observer.disconnect();  // Déconnecter l'observateur
      }
    }

    if (this.mediaSubscription) {
      this.mediaSubscription.unsubscribe();
    }
    // Arrêter la lecture quand le composant est détruit
    this.mediaControlService.stopAll();

    // Nettoyer les écouteurs d'événements
    document.removeEventListener('fullscreenchange', () => {});
    document.removeEventListener('webkitfullscreenchange', () => {});
    document.removeEventListener('mozfullscreenchange', () => {});
    document.removeEventListener('MSFullscreenChange', () => {});

    if (this.youtubePlayer && typeof this.youtubePlayer.destroy === 'function') {
      this.youtubePlayer.destroy();
    }
  }

  openImageModal(imageUrl: string): void {
      
      const dialogRef = this.dialog.open(ImageModalComponent, {
        maxWidth: '100vw',
        maxHeight: '100vh',
        height: 'auto',
        width: 'auto',
        panelClass: 'image-modal-dialog',
        backdropClass: 'image-modal-backdrop',
        data: { imageUrl, allImages: this.getImageUrls() }
      });
  
    }

    formatTimestamp() {
      if (this.postData.timestamp) {
          // Vérification du type du timestamp
          //console.log(this.postData.timestamp);
  
          // Assurez-vous que c'est bien un Firestore Timestamp
          if (this.postData.timestamp.seconds && this.postData.timestamp.nanoseconds !== undefined) {
              const postDate = new Date(this.postData.timestamp.seconds * 1000);
              const currentDate = new Date();
              const timeDifference = currentDate.getTime() - postDate.getTime();
              const oneDayInMs = 86400000; // Nombre de millisecondes dans une journée
              const oneYearInMs = 31536000000; // Nombre de millisecondes dans une année (approximatif)
  
              // Vérifier si la publication a été faite il y a moins de 24 heures
              if (timeDifference < oneDayInMs) {
                  this.formattedDate = postDate.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
  
              // Vérifier si la publication a été faite il y a plus de 24 heures mais moins d'une année
              } else if (timeDifference < oneYearInMs) {
                  this.formattedDate = postDate.toLocaleDateString(undefined, { day: '2-digit', month: '2-digit',  }) /*+ ' ' + postDate.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' }) */;
  
              // Publication faite il y a plus d'une année
              } else {
                  this.formattedDate = postDate.toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' }) + ' ' + postDate.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
              }
          } else {
              console.error('Le timestamp ne semble pas être un Firestore Timestamp.');
          }
      }
  }

  toggleText() {
    this.isExpanded = !this.isExpanded;
    if (!this.isExpanded) {
      // Attendre que le DOM soit mis à jour avant de vérifier à nouveau
      setTimeout(() => {
        this.checkTextOverflow();
      });
    }
  }

  checkTextOverflow() {
    if (this.postText && this.postText.nativeElement) {
      const element = this.postText.nativeElement;
      this.zone.run(() => {
        // Réinitialiser les styles pour obtenir la vraie hauteur
        element.style.maxHeight = 'none';
        element.style.overflow = 'visible';
        
        const lineHeight = parseInt(getComputedStyle(element).lineHeight, 10) || 20;
        const maxHeight = lineHeight * 3; // Limite à 3 lignes
        
        // Vérifier si le contenu dépasse 3 lignes
        this.isTruncated = element.scrollHeight > maxHeight;
        
        if (!this.isExpanded && this.isTruncated) {
          // Appliquer la troncature si nécessaire
          element.style.maxHeight = `${maxHeight}px`;
          element.style.overflow = 'hidden';
        }
      });
    }
  }

  onFollowClick() {
    // Implémentation de la logique pour suivre l'utilisateur
    console.log('Suivre l\'utilisateur', this.postData.creatorId);
  }

  onEditClick() {
    // Implémentation de la logique pour modifier la publication
    //console.log('Modifier la publication', this.postData.postId);
    this.openEditDialog(this.postData);
  }

  onDeleteClick() {
    const dialogRef = this.dialog.open(DeletePostDialogComponent, {
      width: '400px',
      panelClass: 'delete-dialog',
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.firestore.delete({
          path: ["Posts", this.postData.postId],
          onComplete: () => {
            this.snackBar.open('Publication supprimée avec succès', 'OK', { duration: 3000 });
            // Rafraîchir la page ou mettre à jour la liste des posts
            window.location.reload();
          },
          onFail: (err) => {
            console.error(err);
            this.snackBar.open('Erreur lors de la suppression de la publication', 'OK', { duration: 3000 });
          }
        });
      }
    });
  }

  openDeleteDialog(postId: string): void {
    const dialogRef = this.dialog.open(DeletePostDialogComponent);
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deletePost(postId);
      }
    });
  }

  deletePost(postId: string): void {
    this.firestore.delete({
      path: ["Posts", postId],
      onComplete: () => {
       
        location.reload();
      },
      onFail: (err) => {
        console.error("Erreur lors de la suppression : ", err);
      }
    });
  }
  

  toggleFollow() {
    
    if (this.isFollowing) {
      
      this.unfollowUser(this.userIdToFollow, this.currentUserId).then(() => {
        this.isFollowing = false; // Met à jour l'état du bouton
      });
      //this.isFollowing = false;
     /** .then(() => {
        this.isFollowing = false; // Met à jour l'état du bouton
      }); */
    } else {
      this.followUser(this.userIdToFollow, this.currentUserId).then(() => {
        //alert(this.userIdToFollow);
       // alert(this.currentUserId);
        this.isFollowing = true; // Met à jour l'état du bouton

      });
      //this.isFollowing = true;
      /**.then(() => {
        alert(this.userIdToFollow);
        alert(this.currentUserId);
        this.isFollowing = true; // Met à jour l'état du bouton

      }); */
    }
  }

  addNotification(postId: string, interactionType: string, recipientUserId: string, senderUserId: string, senderUserName: string) {
    const firestore = new FirebaseTSFirestore();
  
    const notification = {
      postId: postId,
      interactionType: interactionType,  // 'like' or 'comment'
      recipientUserId: recipientUserId,  // The owner of the post
      senderUserId: senderUserId,        // The person who liked or commented
      senderUserName: senderUserName,
      timestamp: new Date().toISOString(),
      isRead: false
    };
  
    if(recipientUserId != senderUserId){
      firestore.create({
        path: ["Notifications"],
        data: notification,
        onComplete: () => {
          console.log("Notification added successfully");
        },
        onFail: (err) => {
          console.error("Failed to add notification:", err);
        }
      });
    }
  }

  // Méthode pour suivre un utilisateur
  followUser(userIdToFollow: string, currentUserId: string) {
    //alert("Bonjourrrr...");
    this.firestore.appendArray(currentUserId) ;
    //this.isFollowing = true;
    return this.firestore.update({
      path: ['Users', userIdToFollow],
      data: {
        followers: this.firestore.appendArray(currentUserId) // Ajouter l'UID au champ 'followers'
      },
      onComplete: () => {
        console.log('Utilisateur suivi avec succès');
        this.addPostCreatorIdToMyFollowing(userIdToFollow, currentUserId);
        
        //this.isFollowing = true;
      },
      onFail: (err) => {
        console.error('Erreur lors du suivi de l\'utilisateur:', err);
      }
    }); 
  }

  addPostCreatorIdToMyFollowing(userIdToFollow: string, currentUserId: string){
    return this.firestore.update({
      path: ['Users', currentUserId],
      data: {
        following: this.firestore.appendArray(userIdToFollow) // Ajouter l'UID au champ 'followers'
      },
      onComplete: () => {
        console.log('id ajouté à mon following liste avec succès');
        //this.isFollowing = true;
      },
      onFail: (err) => {
        console.error('Erreur lors du suivi de l\'utilisateur:', err);
      }
    });
  }

 



  // Méthode pour se désabonner d'un utilisateur
  async unfollowUser(userIdToUnfollow: string, currentUserId: string) {
    

    try {
      const userToUnFollowRef = doc(this.firestore3, `Users/${userIdToUnfollow}`);
      const myRef = doc(this.firestore3, `Users/${currentUserId}`);

     
     

      await updateDoc(myRef, {
        following: arrayRemove(userIdToUnfollow)  // Retire l'ID de l'utilisateur du tableau des followings de moi
      });

      await updateDoc(userToUnFollowRef, {
        followers: arrayRemove(currentUserId)  // Retire l'ID de l'utilisateur du tableau des followings de moi
      });

      console.log('Désabonnement effectué avec succès!');
    } catch (error) {
      console.error('Erreur lors de la suppression du like:', error);
    }
    
    //this.isFollowing = false;
    //alert("Vous vous êtes désabonné!");
     // Retire l'UID du champ 'followers';
    
  }

  /*// Ne plus suivre un utilisateur en retirant son ID du tableau followers[]
  unfollowUser(currentUserId: string, userId: string): Promise<void> {
    const currentUserRef = this.firestore.collection('Users').doc(userId);
    const Myref = this.firestore.collection('Users').doc(userId);

    Myref.update({
      following: firebase.firestore.FieldValue.arrayRemove(userId) // Retire l'utilisateur courant des followers
    });

    return currentUserRef.update({
      followers: firebase.firestore.FieldValue.arrayRemove(currentUserId) // Retire l'utilisateur courant des followers
    });
  } */

  

  

  async getCreatorInfo(){
    
    await this.firestore.getDocument(
      {
        path: ["Users",  this.postData.creatorId],
        onComplete: result => {
          
          let userDocument = <UserData> result.data();
          this.creatorName = userDocument.publicName;
          this.creatorDescription = userDocument.description;
          this.creatorProfilePhotoUrl = userDocument.profilePhotoUrl;
          this.creatorVille = userDocument.ville ? userDocument.ville : '';
          
          // Vérifier si l'utilisateur est certifié
          this.isCreatorCertified = userDocument.isCertifiedByLenali === true;
        }
      }
    );
    
    
  }

  listenToPost(){
    this.firestore.listenToDocument({
      name: "userFollowersListener",
      path: ["Users",  this.postData.creatorId],
      onUpdate: (result) => {
        const followers = result.data()?.followers ;
        this.isFollowing = followers.includes(this.currentUserId);
      }
    });
  }

  listenToPost2(){
    
    this.firestore.listenToDocument({
      name: "postLikesListener",
      path: ["Posts", this.postId ? this.postId : this.postData.postId],
      onUpdate: (result) => {
        
        //const followers = result.data()?.followers || [];
        //this.isFollowing = followers.includes(this.currentUserId);
        const likes = result.data()?.likes || [];
        //alert(likes);
        //alert(this.currentUserId);
        
        if(likes.includes(this.currentUserId)){
          this.isLiked = true;
        }else{
          this.isLiked = false;
        }
        
        
        //this.isLiked = likes.includes(this.currentUserId);
        //alert(this.isLiked);
        this.likesCount = likes.length;

        //alert(result.data()?.shares);
        //alert(result.ref.collection('PostComments'));
        const comments = [];
        
        this.postData.likes = result.data()?.likes;
        //this.postData.comments = result.data()?.PostComments;
        //this.commentCount = comments.length;
        //alert(this.postData.comments);
        
      }
    });
  }
  

  listenToPost3(){
    this.firestore.listenToCollection(
      {
        name: "Post Comments Length",
        path: ["Posts",this.postId ? this.postId : this.postData.postId, "PostComments"],
        where: [new OrderBy("timestamp", "asc")],
        onUpdate: (result)=> {
          this.commentCount = result.docs.length;
          
          
        }
      } 
    );
    
  }

  listenToPost4(){
    this.firestore.listenToCollection(
      {
        name: "Post Shares Length",
        path: ["Posts", this.postId ? this.postId : this.postData.postId],
        where: [new OrderBy("timestamp", "asc")],
        onUpdate: (result)=> {
          this.sharesCount = result.docs.length;
        }
      } 
    );
    
  }

  

  

  checkIfOwner() {
    const currentUserId = this.auth.getAuth().currentUser.uid;
    this.isOwner = this.postData.creatorId === currentUserId;
  }

  checkIfFollowing() {
    // Implémenter la logique pour vérifier si l'utilisateur actuel suit déjà cet utilisateur
    // Simuler la vérification avec un exemple (à remplacer par la logique réelle)
    this.isFollowing = /* Logique pour déterminer si l'utilisateur suit */ false;
  }

  openEditDialog(post: PostData): void {
    //alert(post);
    const dialogRef = this.dialog.open(EditPostDialogComponent, {
      width: '400px',
      data: post
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.updatePost(post.postId, result.updatedText);
      }
    });
  }

  updatePost(postId: string, newText: string): void {
    //alert("Bonjour");
    this.firestore.update({
      path: ['Posts', postId],
      data: {
        comment: newText
      },
      onComplete: (docId) => {
        console.log('Publication mise à jour avec succès');
        this.snackBar.open('Publication mise à jour avec succès', 'Fermer', {
          duration: 3000,
        });
        this.refreshPage(); // Actualiser la page
      },
      onFail: (err) => {
        console.error('Erreur lors de la mise à jour de la publication:', err);
      }
    });
  }
  
  refreshPage(): void {
    window.location.reload();
  }

  // Méthodes de gestion des liens et prévisualisations
  private extractAndPreviewLink(text: string): void {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const urls = text.match(urlRegex);

    if (urls && urls.length > 0) {
      const url = urls[0];
      
      // Vérifier si c'est une URL YouTube
      const youtubeId = this.getYoutubeVideoId(url);
      if (youtubeId) {
        // Créer une prévisualisation YouTube
        const preview = {
          url: url,
          title: '',  // On va récupérer le vrai titre
          description: '',
          image: `https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg`,
          siteName: 'YouTube',
          isYoutube: true,
          youtubeId: youtubeId
        };

        // Récupérer les métadonnées de la vidéo YouTube
        fetch(`https://noembed.com/embed?url=${encodeURIComponent(url)}`)
          .then(response => response.json())
          .then(data => {
            preview.title = data.title || 'Vidéo YouTube';
            preview.description = data.description || '';

            if (this.postData && this.postData.postId) {
              this.firestore.update({
                path: ["Posts", this.postData.postId],
                data: { linkPreview: preview },
                onComplete: () => {
                  console.log('Prévisualisation YouTube mise à jour avec succès');
                  this.postData.linkPreview = preview;
                },
                onFail: (error) => {
                  console.error('Erreur lors de la mise à jour de la prévisualisation:', error);
                }
              });
            }
          })
          .catch(error => {
            console.error('Erreur lors de la récupération des métadonnées YouTube:', error);
            // Continuer avec les données de base
            if (this.postData && this.postData.postId) {
              this.firestore.update({
                path: ["Posts", this.postData.postId],
                data: { linkPreview: preview },
                onComplete: () => {
                  this.postData.linkPreview = preview;
                },
                onFail: (error) => {
                  console.error('Erreur lors de la mise à jour de la prévisualisation:', error);
                }
              });
            }
          });
        return;
      }

      // Si ce n'est pas YouTube, continuer avec l'API de prévisualisation normale
      fetch(`https://api.linkpreview.net/?key=c6d4082b022377ddb9ead5e7d4ac5bd5&q=${encodeURIComponent(url)}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('Erreur réseau lors de la récupération de la prévisualisation');
          }
          return response.json();
        })
        .then(data => {
          if (!data || !data.title) {
            console.log('Pas de données de prévisualisation valides reçues');
            return;
          }

          const preview = {
            url: url,
            title: data.title || '',
            description: data.description || '',
            image: data.image || '',
            siteName: data.siteName || new URL(url).hostname,
            isYoutube: false
          };

          if (this.postData && this.postData.postId) {
            this.firestore.update({
              path: ["Posts", this.postData.postId],
              data: { linkPreview: preview },
              onComplete: () => {
                console.log('Prévisualisation du lien mise à jour avec succès');
                this.postData.linkPreview = preview;
              },
              onFail: (error) => {
                console.error('Erreur lors de la mise à jour de la prévisualisation:', error);
              }
            });
          }
        })
        .catch(error => {
          console.error('Erreur lors de la récupération de la prévisualisation:', error);
        });
    }
  }

  // Méthodes de gestion des vidéos YouTube
  private getYoutubeVideoId(url: string): string | null {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  }

  private getYoutubeEmbedUrl(videoId: string, autoplay: boolean = false): string {
    const params = [
      'enablejsapi=1',
      'rel=0',
      'modestbranding=1',
      autoplay ? 'autoplay=1' : '',
      'playsinline=1'
    ].filter(Boolean).join('&');
    
    return `https://www.youtube.com/embed/${videoId}?${params}`;
  }

  private transformYoutubeUrl(url: string): string {
    const videoId = this.getYoutubeVideoId(url);
    if (videoId) {
      return this.getYoutubeEmbedUrl(videoId);
    }
    return url;
  }

  private onYoutubeIframeLoad(event: Event): void {
    const iframe = event.target as HTMLIFrameElement;
    this.youtubePlayer = new (window as any).YT.Player(iframe, {
      events: {
        'onReady': (e: any) => {
          this.youtubePlayerReady = true;
          if (this.pendingPlay) {
            e.target.playVideo();
            this.pendingPlay = false;
          }
        },
        'onStateChange': (e: any) => {
          if (e.data === (window as any).YT.PlayerState.ENDED) {
            this.stopYoutubeVideo(new Event('ended'));
          }
        }
      }
    });
  }

  playYoutubeVideo(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.isYoutubeVideoPlaying = true;
  }

  stopYoutubeVideo(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.isYoutubeVideoPlaying = false;
  }

  onPostUpdate(newText: string): void {
    if (newText) {
      this.extractAndPreviewLink(newText);
    }
  }

  toggleLike() {

    
    
    //const postRef = firebase.firestore().collection('Posts').doc(this.postData.postId);
    

      this.firestore.getDocument({
        path: ["Posts", this.postData.postId],
        onComplete: async (result) => {
          //let post = <PostData>result.data();
          const postData = <PostData>result.data();
          const likes = postData?.likes || [];

          if (likes.includes(this.currentUserId)) {
            
            await this.removeLikeFromPost(this.postData.postId, this.currentUserId);
            // L'utilisateur a déjà aimé, donc on enlève le like
            /**this.firestore.update ( {
              path: [ postRef.path],
              data: { likes: firebase.firestore.FieldValue.arrayRemove(this.currentUserId)},
              onComplete: docRef=> {
              // Code gets executed when it was successful.
              console.log('Like supprimé');
              },
              onFail: err => {
              // Code gets executed when it fails.
              alert(err.message);
              } }); */


              /** postRef.update({
              likes: firebase.firestore.FieldValue.arrayRemove(this.currentUserId)
            }).then(() => {
              console.log('Like supprimé');
            }).catch(error => {
              console.error('Erreur lors de la suppression du like : ', error);
            }); */
          } else {
            
            
            // L'utilisateur n'a pas encore aimé, donc on ajoute le like
            await this.addLikeToPost(this.postData.postId, this.currentUserId);
            
            this.addNotification(this.postData.postId, "aimé", this.postData.creatorId, this.currentUserId, this.currentUser.publicName);
            /*this.firestore.update({
              path: [ postRef.path],
              data: { likes: firebase.firestore.FieldValue.arrayUnion(this.currentUserId)},
              
            }).then(() => {
              console.log('Like ajouté');
            }).catch(error => {
              console.error('Erreur lors de l\'ajout du like : ', error);
            }); */
          }
            
         
        },
        onFail: err => {
          console.error(err);
        }
      }
      )
      
      /*postRef.get().then(doc => {
        if (doc) {
          
          const postData = <PostData>doc.data();
          const likes = postData?.likes || []; // Assurez-vous que likes est défini comme un tableau

          if (likes.includes(this.currentUserId)) {
            // L'utilisateur a déjà aimé, donc on enlève le like
            postRef.update({
              likes: firebase.firestore.FieldValue.arrayRemove(this.currentUserId)
            }).then(() => {
              console.log('Like supprimé');
            }).catch(error => {
              console.error('Erreur lors de la suppression du like : ', error);
            });
          } else {
            
            // L'utilisateur n'a pas encore aimé, donc on ajoute le like
            postRef.update({
              likes: firebase.firestore.FieldValue.arrayUnion(this.currentUserId)
            }).then(() => {
              console.log('Like ajouté');
            }).catch(error => {
              console.error('Erreur lors de l\'ajout du like : ', error);
            });
          }
        } else {
          //alert("le document n'existe pas");
          console.error('Le document de la publication n\'existe pas');
        }
      }).catch(error => {
        console.error('Erreur lors de la récupération du document : ', error);
      }); */
  }

  async addLikeToPost(postId: string, userId: string): Promise<void> {
    this.loadUserProfile();
    console.log(this.currentUser);
    try {
      const postRef = doc(this.firestore3, `Posts/${postId}`);
      
      
      // Mise à jour du document pour ajouter un like
      await updateDoc(postRef, {
        likes: arrayUnion(userId)  // Ajoute l'ID de l'utilisateur au tableau des likes
      });

      console.log('Like ajouté avec succès!');
    } catch (error) {
      console.error('Erreur lors de l\'ajout du like:', error);
    }
  }

  async removeLikeFromPost(postId: string, userId: string): Promise<void> {
    try {
      const postRef = doc(this.firestore3, `Posts/${postId}`);

      // Mise à jour du document pour retirer un like
     
      await updateDoc(postRef, {
        likes: arrayRemove(userId)  // Retire l'ID de l'utilisateur du tableau des likes
      });

      console.log('Like supprimé avec succès!');
    } catch (error) {
      console.error('Erreur lors de la suppression du like:', error);
    }
  }

  // post.component.ts
  sharePost() {
    const postRef = firebase.firestore()
      .collection('Users')
      .doc(this.postData.creatorId)
      .collection('Posts')
      .doc(this.postData.postId);
  
    // Ajouter l'UID de l'utilisateur au tableau "shares"
    postRef.update({
      shares: firebase.firestore.FieldValue.arrayUnion(this.userId)
    }).then(() => {
      console.log('Post shared successfully!');
    }).catch(error => {
      console.error('Error sharing post: ', error);
    });
  }

  addComment(newComment: CommentData) {
    const postRef = firebase.firestore()
      .collection('Users')
      .doc(this.postData.creatorId)
      .collection('Posts')
      .doc(this.postData.postId);
  
    // Ajouter le commentaire au tableau "comments"
    postRef.update({
      comments: firebase.firestore.FieldValue.arrayUnion(newComment)
    }).then(() => {
      console.log('Comment added successfully!');
    }).catch(error => {
      console.error('Error adding comment: ', error);
    });
  }

  // Méthode pour ouvrir le dialogue de commentaires
  openCommentDialog(): void {
    
  
    const dialogRef = this.dialog.open(CommentDialogComponent, {
      width:'500px', // Largeur pleine pour mobile
      data: {
        postData: this.postData // Envoyer les données du post au composant de dialogue
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Gérer le résultat du dialogue ici, par exemple, actualiser la liste des commentaires
        console.log('Comment added:', result);
      }
    });
  }


  loadComments(): void {
    // Vérifier si le post existe et a des commentaires
    if (this.postData && this.postData.postId) {
      const postRef = doc(this.firestore3, 'Posts', this.postData.postId);
      
      // Obtenir les commentaires du post
      this.firestore.getDocument({
        path: ["Posts", this.postData.postId],
        onComplete: (result) => {
          const post = result.data() as PostData;
          if (post && post.comments) {
            this.comments = post.comments;
            this.commentCount = this.comments.length;
          } else {
            this.comments = [];
            this.commentCount = 0;
          }
        },
        onFail: (error) => {
          console.error("Erreur lors du chargement des commentaires : ", error);
          this.comments = [];
          this.commentCount = 0;
        }
      });
    }
  }

  getPost(postId: string): Observable<any> {
    return new Observable((observer) => {
      this.firestore.listenToDocument({
        name: "Getting Post",
        path: ["Posts", postId],
        onUpdate: (result) => {
          observer.next(result.data());
        }
      });

      // Return a cleanup function
      return () => {
        // Nothing to unsubscribe since listenToDocument doesn't return an unsubscribe function
      };
    });
  }

  onComplete(result: firebase.firestore.QuerySnapshot): void {
    result.docs.forEach(
      doc => {
        let post = <PostData>doc.data();
        post.postId = doc.id;
        this.postData = post;
      }
    );
  }

  onFail(error: any): void {
    console.error("Error loading post: ", error);
  }

  onVideoLoaded(event: Event) {
    const video = event.target as HTMLVideoElement;
    this.duration = video.duration;
    this.updateProgressBar();
    
    // Ajouter les écouteurs d'événements
    video.addEventListener('play', () => this.isPlaying = true);
    video.addEventListener('pause', () => this.isPlaying = false);
    video.addEventListener('ended', () => this.isPlaying = false);
  }

  onTimeUpdate(event: Event) {
    const video = event.target as HTMLVideoElement;
    this.currentTime = video.currentTime;
    this.updateProgressBar();
  }

  togglePlay() {
    const video = this.videoPlayer.nativeElement;
    if (video.paused) {
      video.play().then(() => {
        this.isPlaying = true;
      }).catch(error => {
        console.error('Erreur lors de la lecture:', error);
        this.isPlaying = false;
      });
    } else {
      video.pause();
      this.isPlaying = false;
    }
  }

  seekVideo(event: Event) {
    const input = event.target as HTMLInputElement;
    const video = this.videoPlayer.nativeElement;
    const time = Number(input.value);
    video.currentTime = time;
    this.updateProgressBar();
  }

  formatTime(time: number): string {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  updateProgressBar(): void {
    if (this.videoPlayer?.nativeElement) {
      const video = this.videoPlayer.nativeElement;
      const progress = (video.currentTime / video.duration) * 100;
      document.documentElement.style.setProperty('--progress-percent', `${progress}%`);
    } else if (this.audioPlayer?.nativeElement) {
      const audio = this.audioPlayer.nativeElement;
      const progressBar = document.querySelector('.progress-bar') as HTMLElement;
      if (progressBar && !isNaN(audio.duration)) {
        const progress = (audio.currentTime / audio.duration) * 100;
        progressBar.style.width = `${progress}%`;
      }
    }
  }

  onImageLoad(event: Event) {
    const img = event.target as HTMLImageElement;
    const container = img.parentElement;
    
    if (container) {
      // Pour les images uniques ou celles qui ne remplissent pas naturellement leur conteneur
      if (this.getImageUrls().length === 1 || 
         (img.naturalWidth && img.naturalHeight && 
          img.naturalWidth / img.naturalHeight !== container.clientWidth / container.clientHeight)) {
          
        // Utiliser la même image comme arrière-plan flou
        container.style.setProperty('--image-url', `url('${img.src}')`);
        container.classList.add('has-blur-background');
        
        // Ajuster la hauteur du conteneur à l'image pour éviter les grands espaces vides
        if (this.getImageUrls().length === 1) {
          const imageContainer = container.parentElement;
          if (imageContainer) {
            // Supprimer les hauteurs fixes
            imageContainer.style.height = 'auto';
            imageContainer.style.minHeight = 'auto';
            
            // Fix spécifique pour les petits écrans
            if (window.innerWidth <= 768) {
              // Forcer la hauteur à être exactement celle de l'image
              setTimeout(() => {
                const imgHeight = img.clientHeight;
                if (imgHeight > 0) {
                  // Ajouter une petite marge pour éviter les problèmes de mise en page
                  imageContainer.style.height = imgHeight + 'px';
                  container.style.height = imgHeight + 'px';
                }
              }, 50); // Petit délai pour s'assurer que l'image est chargée
            }
          }
        }
      }
    }
  }

  getImageUrls(): string[] {
    if (!this.postData) return [];
    
    // Si imageUrls existe et n'est pas vide, l'utiliser
    if (this.postData.imageUrls && this.postData.imageUrls.length > 0) {
      return this.postData.imageUrls;
    }
    
    // Sinon, si imageUrl existe, le retourner dans un tableau
    if (this.postData.imageUrl) {
      return [this.postData.imageUrl];
    }
    
    // Si aucune image n'est disponible, retourner un tableau vide
    return [];
  }

  toggleMute() {
    const video = this.videoPlayer.nativeElement;
    if (this.isMuted) {
      video.volume = this.previousVolume;
      this.volume = this.previousVolume;
      this.isMuted = false;
    } else {
      this.previousVolume = this.volume;
      video.volume = 0;
      this.volume = 0;
      this.isMuted = true;
    }
    this.updateVolumeUI();
  }

  updateVolume(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = Number(input.value) / 100;
    this.volume = value;
    this.videoPlayer.nativeElement.volume = value;
    this.isMuted = value === 0;
    this.updateVolumeUI();
  }

  updateVolumeUI() {
    document.documentElement.style.setProperty('--volume-percent', `${this.volume * 100}%`);
  }

  

  // Méthode pour fermer le modal
  closeImageModal() {
    this.selectedImage = null;
  }

  // Navigation vers l'image précédente
  previousImage() {
    if (this.currentImageIndex > 0) {
      this.currentImageIndex--;
      this.selectedImage = this.getImageUrls()[this.currentImageIndex];
    }
  }

  // Navigation vers l'image suivante
  nextImage() {
    if (this.currentImageIndex < this.getImageUrls().length - 1) {
      this.currentImageIndex++;
      this.selectedImage = this.getImageUrls()[this.currentImageIndex];
    }
  }
}
